import classnames from 'classnames';
import {
  CKLayoutGridAuto,
  CKLayoutGridAutoProps,
  CKLayoutHorizontal,
  CKLayoutHorizontalProps,
} from 'clearkit';
import { CSSProperties, useEffect, useRef, useState } from 'react';

export type CreditOption = {
  credits: number;
  cost: number;
};

type CreditSelectorLabelProps = CKLayoutHorizontalProps & {
  activeIndex: number;
  isOnlySelectedVisible?: boolean;
  index: number;
  lastOption: number;
  option: CreditOption;
};

export const CreditSelectorLabel = ({
  activeIndex,
  children,
  index,
  isOnlySelectedVisible,
  lastOption,
  option,
}: CreditSelectorLabelProps) => {
  const [offsetWidth, setOffsetWidth] = useState(0);
  const badgeRef = useRef<HTMLSpanElement>(null);

  const isSelected = index === activeIndex;
  const isLastOption = index === lastOption;

  const styles = {
    marginInlineStart: isLastOption ? 'auto' : `-${offsetWidth / 2}px`,
    marginInlineEnd: isLastOption ? `-${offsetWidth / 2}px` : 'auto',
  } as CSSProperties;

  useEffect(() => {
    setOffsetWidth(badgeRef.current?.offsetWidth ?? 0);
  }, [badgeRef.current]);

  return (
    <CKLayoutHorizontal
      as="span"
      className={classnames({
        'absolute right-0': isLastOption,
      })}
      gap="0"
      justifyContent="start"
      key={option.credits}
    >
      <span
        className={classnames(
          'border inline-block p-1 px-1.5 leading-none relative text-base rounded text-center transition-opacity',
          {
            'border-transparent text-gray-900 bg-transparent': !isSelected,
            'opacity-0': !isSelected && isOnlySelectedVisible,
            'border-purple-200 bg-purple-0': isSelected,
          },
        )}
        ref={badgeRef}
        style={styles}
      >
        <span
          className={classnames({
            'inline-block ck-gradient-text ck-gradient-text--x': isSelected,
          })}
        >
          {children}
        </span>
      </span>
    </CKLayoutHorizontal>
  );
};

export const CreditSelectorLabelGrid = ({
  children,
  className,
  ...rest
}: CKLayoutGridAutoProps) => {
  return (
    <CKLayoutGridAuto
      {...rest}
      as="span"
      autoRepeat="auto-fit"
      className={classnames('relative w-full', className)}
      gap="0"
      minWidth="1rem"
    >
      {children}
    </CKLayoutGridAuto>
  );
};
